var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32374 4H0.676264C0.113017 4 -0.202493 3.39719 0.145493 2.98592L2.46923 0.239557C2.73949 -0.0798525 3.26051 -0.0798525 3.53077 0.239557L5.85451 2.98592C6.20249 3.39719 5.88698 4 5.32374 4Z",
    fill: "#5C5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.676263 6L5.32374 6C5.88698 6 6.20249 6.60281 5.85451 7.01408L3.53077 9.76044C3.26051 10.0799 2.73949 10.0799 2.46923 9.76044L0.145493 7.01408C-0.202494 6.60281 0.113017 6 0.676263 6Z",
    fill: "#5C5F62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectOption);
export default __webpack_public_path__ + "static/media/selectOption.a726f3a36f46f29aeb773bab5e80157b.svg";
export { ForwardRef as ReactComponent };